import React, { useEffect, useState } from "react";
import Popover from "@mui/material/Popover";
import ContactSupportIcon from "../assets/logo/question-line.svg";
import Fab from "@mui/material/Fab";
import Zoom from "@mui/material/Zoom";
import { Link, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import HelpLinks from "../data/support-links";
import { ONBOARDING_GUIDE_LINK } from "../utils/config";
import { logEvent } from "../store/api";
import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS } from "../utils/events";
import { removeDynamicPart, removeNonCryptoHelp } from "../utils";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
export default function AppFabSupport() {
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const [links, setLinks] = useState(null);
  const {  t } = useTranslation();

  const enableFiat = useSelector(({ dashboard }) => !!dashboard?.fiatService?.enableFiat);
  useEffect(() => {
    const help = removeNonCryptoHelp(HelpLinks[removeDynamicPart(location.pathname)], enableFiat);
    setLinks(help);
  }, [enableFiat, location.pathname]);
  useEffect(() => {
    if (!links || !links.length) {
      setAnchorEl(null);
    }
  }, [links]);

  const handleClick = (event) => {
    logEvent({
      current: EVENTS.HELP.HELP_BUTTON,
      activity: ACTIVITY_DETAIL.HELP.HELP_BUTTON,
      meta: {
        data: {
          pathname: location.pathname,
          source: ACTIVITY_META.HELP.HELP_BUTTON
        }
      }
    });
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    logEvent({
      current: EVENTS.HELP.HELP_BUTTON,
      activity: ACTIVITY_DETAIL.HELP.HELP_BUTTON_CLOSE,
      meta: {
        data: {
          pathname: location.pathname,
          source: ACTIVITY_META.HELP.HELP_BUTTON_CLOSE
        }
      }
    });
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            background: "transparent",
            bottom: "100px !important",
            top: "unset !important",
            right: "25px !important",
            left: "unset !important",
            boxShadow: "none",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-end",
          },
        }}
      >
        {!!links &&
          links.length &&
          links.map((val, index) => (
            <Box
              key={index}
              marginTop={4}
              sx={{ backgroundColor: "#F8FAFF" }}
              paddingTop={0.8}
              paddingBottom={0.8}
              borderRadius={2}
              paddingRight={0.5}
              paddingLeft={0.5}
              width={"fit-content"}
              onClick={() => {
                logEvent({
                  current: EVENTS.HELP.HELP_LINK,
                  activity: ACTIVITY_DETAIL.HELP.HELP_LINK,
                  meta: {
                    data: {
                      pathname: location.pathname,
                      source: ACTIVITY_META.HELP.HELP_LINK,
                      link: `${ONBOARDING_GUIDE_LINK}${val.link}`
                    }
                  }
                })
              }}
            >
              <Link
                textAlign={"right"}
                width={"100%"}
                display={"block"}
                sx={{ cursor: "pointer", textDecoration: "none" }}
                href={ONBOARDING_GUIDE_LINK + val.link}
                color={"#003B6A"}
                target="_blank"
                fontSize={14}
                fontWeight={700}
                fontFamily={"Manrope"}
              >
                {t(val.title)}
              </Link>
            </Box>
          ))}
      </Popover>
      {!!(links && links.length) && (
        <Zoom key={"fab-icon"} in={true} timeout={500}>
          <Fab
            onClick={handleClick}
            color={"#D4D4D8"}
            sx={{
              position: "fixed",
              right: 20,
              bottom: 20,
              background: "rgba(0, 136, 245, 0.15)",
              mixBlendMode: "screen",
              border: "1px solid rgba(0, 136, 245, 0.8)",
              boxShadow: "2px 2px 24px rgba(0, 136, 245, 0.24)",
              "&:hover": {
                background: 'inherit'
              }
            }}
          >
            <ContactSupportIcon />
          </Fab>
        </Zoom>
      )}
    </>
  );
}

AppFabSupport.propTypes = {};
